// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import iconFactory from 'syft-acp-atoms/Icons'

import './IconInfo.css'

// Decorative: the glossed control carries the same text via aria-describedby.
const IconFactory = iconFactory('info', 'hidden')

// An anchor, not a button: FilterGroup renders its title inside the <label> that wraps
// the select, and a button is labelable, so it would take the label and leave the select
// unnamed. The click is cancelled because a label otherwise forwards clicks to its
// control. Once FilterGroup stops using <label> as a container this can become an IFL
// ToggleTooltip, as the modal already does, and this component can go.
/* eslint-disable jsx-a11y/anchor-is-valid */
const IconInfo = ({ tooltipID, testID }: { tooltipID: string; testID: string }) => (
  <a
    className="infoIcon"
    data-for={tooltipID}
    data-testid={testID}
    data-tip
    aria-hidden="true"
    onClick={event => event.preventDefault()}
  >
    <IconFactory iconSize={14} fill="currentColor" />
  </a>
)
/* eslint-enable jsx-a11y/anchor-is-valid */

export default IconInfo
